import React from 'react'
import { Card } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import classnames from 'classnames'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  Card: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.grey[200],
  },
  CardPadding: {
    padding: 48,
  },
  CardLarge: {
    borderRadius: 8,
  },
  CardHover: {
    '&:hover': {
      borderColor: theme.palette.grey[300],
      backgroundColor: theme.palette.grey[50],
    },
  },
}))

const FlatCard = ({ classes: propClasses = {}, padding = false, large = false, hover = false, ...attrs }) => {
  const classes = useStyles()

  return (
    <Card
      elevation={0}
      classes={{
        ...propClasses,
        root: classnames([classes.Card, hover && classes.CardHover, padding && classes.CardPadding, large && classes.CardLarge, propClasses.root]),
      }}
      {...attrs}
    />
  )
}

FlatCard.propTypes = {
  classes: PropTypes.object,
  padding: PropTypes.bool,
  large: PropTypes.bool,
  hover: PropTypes.bool,
}

export default FlatCard
